import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["summary", "form", "submit"];

  connect() {
    this.updateSubmitState();
  }

  expandForm() {
    this.summaryTarget.setAttribute("hidden", "");
    this.formTarget.removeAttribute("hidden");
  }

  collapseForm() {
    this.formTarget.reset();
    this.formTarget.setAttribute("hidden", "");
    this.summaryTarget.removeAttribute("hidden");
  }

  updateSubmitState() {
    const anyChecked = this.formTarget.querySelectorAll("input[type=checkbox]:checked").length > 0;
    this.submitTarget.disabled = !anyChecked;
  }
}
